import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToolbarWidgetType } from '../ToolbarWidgetType';

@Component({
  selector: 'app-tool-action',
  templateUrl: './tool-action.component.html',
  styleUrls: ['./tool-action.component.scss'],
  })
export class ToolActionComponent {
  @Input() widgetType: ToolbarWidgetType;
  @Input() toolPosition: 'left' | 'right' | 'above' | 'below' = 'left';
  @Input() disabled = false;
  @Input() counter = 0;
  @Output() onToolToggle = new EventEmitter<ToolbarWidgetType>();

  toggle() {
    if (this.disabled) {
      return;
    }

    this.onToolToggle.emit(this.widgetType);
  }

  get name() {
    return `toolbar.tools.${this.widgetType.name}.name`;
  }
}
